import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@cmps/ng-bootstrap';
import {
    CmpsAccordionModule,
    CmpsButtonModule,
    CmpsChipModule,
    CmpsDialogModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsMenuModule,
    CmpsPortalModule,
    CmpsRadioModule,
    CmpsSelectModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsDateRangeModule } from '../../../common/component/date-range';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsTeamsCallAuthModule } from '../../auth';

import { NewTaskComponent } from './component/new-task/new-task.component';
import { TranslationIdMap as NewTaskTranslationIdMap } from './component/new-task/new-task.component.i18n';
import { SearchFilterComponent } from './component/search-filter/search-filter.component';
import { TranslationIdMap as SearchFilterTranslationIdMap } from './component/search-filter/search-filter.component.i18n';
import { TaskActionsComponent } from './component/task-actions/task-actions.component';
import { TaskMarkerComponent } from './component/task-marker/task-marker.component';
import { TaskPropsComponent } from './component/task-props/task-props.component';
import { TaskTitleComponent } from './component/task-title/task-title.component';
import { TaskComponent } from './component/task/task.component';
import { TranslationIdMap as TaskTranslationIdMap } from './component/task/task.component.i18n';
import { TaskListDialogComponent } from './task-list-dialog.component';
import { TranslationIdMap as DialogTranslationIdMap } from './task-list-dialog.i18n';
import { TaskListDialogService } from './task-list-dialog.service';

@NgModule({
    declarations: [
        NewTaskComponent,
        SearchFilterComponent,
        TaskActionsComponent,
        TaskComponent,
        TaskListDialogComponent,
        TaskMarkerComponent,
        TaskPropsComponent,
        TaskTitleComponent,
    ],
    providers: [TaskListDialogService],
    imports: [
        CmpsButtonModule,
        CmpsChipModule,
        CmpsCommonModule,
        CmpsDateRangeModule,
        CmpsDialogModule,
        CmpsFilterModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(DialogTranslationIdMap),
        CmpsLazyI18nModule.forChild(NewTaskTranslationIdMap),
        CmpsLazyI18nModule.forChild(SearchFilterTranslationIdMap),
        CmpsLazyI18nModule.forChild(TaskTranslationIdMap),
        CmpsMenuModule,
        CmpsPortalModule,
        CmpsRadioModule,
        CmpsSelectModule,
        CmpsTeamsCallAuthModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CmpsAccordionModule,
        NgbDatepickerModule,
    ],
})
export class CmpsTaskListDialogModule {}
